import * as userService from '@/services/user.service';

const getUserInfo = async (accessToken) => {
  const response = await userService.getUserInfo(accessToken);
  return response.data;
};

export default getUserInfo;
